var _rect, _path, _g, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    fill: "none",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "#242938",
    rx: 60
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#536B8A",
    d: "M159.906 222.623L227.655 34.2294C228.803 31.0342 226.993 28.7045 223.613 29.0304L170.335 34.1627C166.956 34.4887 163.305 37.3561 162.189 40.562L99.4813 220.606C98.364 223.812 100.214 226.415 103.609 226.415H155.467C157.164 226.415 159.009 225.118 159.583 223.52L159.906 222.623Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_148_1050)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M152.178 223.52L123.971 142.035L128 139.516L156.711 222.623L152.178 223.52Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5D87BF",
    d: "M32.3873 29.0304L85.6647 34.1627C89.0442 34.4887 92.6987 37.3547 93.8207 40.5592L157.855 223.512C158.415 225.114 157.492 226.415 155.794 226.415H103.609C100.214 226.415 96.5244 223.821 95.3754 220.626L28.3453 34.2294C27.1967 31.0342 29.0074 28.7045 32.3873 29.0304Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_148_1050",
    width: 58.502,
    height: 109.765,
    x: 111.09,
    y: 126.635,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_148_1050",
    stdDeviation: 6.44
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVDark);
export default __webpack_public_path__ + "static/media/V-Dark.274e572c116d4fbe6403a7b2ece2b834.svg";
export { ForwardRef as ReactComponent };